<template>
    <div class="category">
        <div class="category-title">
            {{title}}
            <span class="refresh" v-if="refresh"  @click="refreshClick">
            <img src="@static/img/refresh.svg" class="btn-icon"/>换一换</span>
        </div>
        <div class="category-list">
            <div class="center" v-if="!items || items.length == 0">{{empty}}</div>
            <template v-else>
                <div class="category-item" v-for="(item, index) in items" :key="index" @click="gotoDetail(item.id, item.catalogType)">
                    <div class="number" :class="'number-'+(index+1)" >{{index+1}}</div>
                    <a href="#" class="link">{{item.cname}}</a>
                </div>
            </template>
        </div>

        <!-- 仪器二维码区域 -->
         <div class="qrcode-section" v-if="catalogType == 'INSTRUMENT_DATA' && resData.qrcodeVisibleStatus === '1'">
            <div class="category-title">
                预约二维码
            </div>
            <div class="qrcode-container">
                <div class="qrcode-item">
                    <div class="qrcode-box">
                        <div class="qrcode-preview" v-loading="appointmentQrLoading">
                            <img  :src="appointmentQrUrl" alt="预约二维码"/>
                        </div>
                        <h3>请扫码预约</h3>
<!--                        <el-button class="box-button" plain :icon="Download" @click="downFile">预约申请说明文档</el-button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'
import { ref } from 'vue'
import {Download} from '@element-plus/icons-vue'
export default {
    computed: {
        Download() {
            return Download
        }
    },
   data(){
       return {
           appointmentQrUrl: '',
           usageQrUrl: '',
           appointmentQrLoading: false,
           usageQrLoading: false
       }
   },
   props:{
       title:{
           type: String,
           default: ''
       },
       catalogType:{
         type: String,
         default: ''
       },
       items:{
           type: Array,
           default:[]
       },
       refresh:{
           type: Boolean,
           default: false
       },
       empty: {
            type: String,
            default: '暂无数据'
       },
       resData: {
            type: Object,
            default: () => ({})
       },
       deviceId: {
            type: String,
            default: ''
       }
   },
   watch: {
       deviceId: {
           handler(newVal) {
               if (newVal) {
                   this.generateQRCode();
               }
           },
           immediate: true
       }
   },
   methods:{
       downFile(){
           window.open("/gdsti2/resource/a/resDataFormInstrument/downYuyueFile.do");
       },
       gotoDetail(id, catalogType){

            let query = {id: id, catalogType: catalogType};
           if(this.$store.state.siteType === this.$enumVals.SiteTypeEnum.ZHUHAI.type){
               //珠海
               this.$router.push({
                   path: '/zhuhai/zhuhaiInstrumentInfo',
                   query: query
               });
           }else if(this.$store.state.siteType === this.$enumVals.SiteTypeEnum.ZHAOQING.type){
               //肇庆
               this.$router.push({
                   path: '/zhaoqing/zhaoqingInstrumentInfo',
                   query: query
               });
           }else{
               //默认
               this.$router.push({
                   path: '/instrument',
                   query: query
               });
           }

           // this.$router.push({name:'Instrument', path:'/instrument', query: {id: id, catalogType: catalogType}})
       },
       refreshClick(){
           this.$emit('refresh', {});
       },
       generateQRCode() {
            // 获取当前域名作为基础URL
            const baseUrl = window.location.origin;
            const qrContent = `${baseUrl}/mappv/device/reservation-form?deviceId=${this.deviceId}`;
            
            this.appointmentQrLoading = true;
            
            QRCode.toDataURL(qrContent, { width: 200, height: 200 })
                .then(url => {
                    this.appointmentQrUrl = url;
                    this.appointmentQrLoading = false;
                })
                .catch(err => {
                    console.error('生成二维码失败:', err);
                    this.$message.error('生成二维码失败');
                    this.appointmentQrLoading = false;
                });
        }
   }
}
</script>

<style lang="less" scoped>
.category{
    background: #FFFFFF;
    
    .category-title{
        font-family: SourceHanSansCN-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: justify;
        background: #007EEC;
        line-height: 40px;
        padding-left: 17px;
        padding-right: 17px;
       
    }
    .refresh{
        float: right;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .refresh:hover{
        color: rbga(0,0,0,0.5);
    }
    .category-list{
        border: 1px solid #E7E7E7;
        padding: 17px;
        .category-item{
            display: flex;
            align-items: center;
            cursor: pointer;

            .number{
                display: inline-block;
                margin-right: 14px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                background: #959595;
                min-width: 18px;
                height: 18px;
                line-height: 18px;
                border-radius: 18px;
            }
            .number-1{
                background: #df2222;
            }
            .number-2{
                background: #fa8131;
            }
            .number-3{
                background: #f7b500;
            }
            .link{
                text-decoration: none;
                font-family: PingFangSC-Regular;
                font-size: 18px;
                color: #000;
                word-break: keep-all;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 34px;
            }
            .link:hover{
                color:#959595;
            }
        }
    }

    .qrcode-section {
        margin-top: 20px;
        border: 1px solid #E7E7E7;

        .qrcode-container {
            padding: 20px;

            .qrcode-item {
                margin-bottom: 20px;
                
                        h3 {
                            font-size: 20px;
                            color: #333;
                            margin: 15px 0;
                            text-align: center;
                            font-weight: bold;
                        }

                .qrcode-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;

                    .qrcode-preview {
                        width: 200px;
                        height: 200px;
                        border: 1px solid #eee;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 10px;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }

                        .qrcode-placeholder {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #999;
                            font-size: 14px;
                            background: #f5f7fa;
                        }
                    }
                }
            }
        }
    }
}
</style>
